import { ShieldCheck, ShieldAlert } from "lucide-react";
import { ulogIntegrityRows, ulogIntegrityBadge } from "@/lib/flightSessions";

// ULOG.OBS.3 — carte LECTURE SEULE : aucune action drone, aucune revalidation depuis l'UI.
export const UlogIntegrityCard = ({ integrity }) => {
  const rows = ulogIntegrityRows(integrity);
  const rv = integrity?.revalidation;
  const crit = integrity?.crc_match === false || integrity?.status === "INTEGRITY_FAILED";
  const b = ulogIntegrityBadge(integrity?.verification_level, crit ? "CRITICAL" : integrity?.integrity_error ? "WARNING" : null);
  const Icon = crit ? ShieldAlert : ShieldCheck;
  return (
    <div className="bg-[#111] border border-white/10 rounded-sm p-3 mb-5" data-testid="fsd-ulog-integrity">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.15em] uppercase text-[#A3A3A3]">
          <Icon size={13} style={{ color: b.c }} /> Intégrité ULog
        </div>
        <span data-testid="fsd-crc-badge" className="font-mono text-[10px] px-1.5 py-0.5 rounded-sm border"
          style={{ color: b.c, borderColor: b.c + "55", background: b.c + "11" }}>{b.l}</span>
      </div>
      {!integrity && (
        <div data-testid="fsd-crc-unknown" className="font-mono text-[11px] text-[#525252]">
          Informations d'intégrité non disponibles pour cette session.
        </div>
      )}
      {integrity && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-1.5">
          {rows.map(([label, value, testid]) => (
            <div key={testid} className="font-mono text-[11px]">
              <span className="text-[#525252]">{label} : </span>
              <span data-testid={testid} className="text-white break-all">{value}</span>
            </div>
          ))}
        </div>
      )}
      {rv && (
        <div data-testid="fsd-revalidation" className="mt-2 font-mono text-[10px] text-[#A3A3A3]">
          Revalidé ({rv.method || "inconnu"}) — statut précédent {rv.previous_status || "inconnu"}
          {rv.previous_error ? ` (${rv.previous_error})` : ""}
        </div>
      )}
    </div>
  );
};
